module.exports = __webpack_public_path__ + "img/913-e6d867.png";